

































































































import '../../styles/cart.less'
import { Component, Vue } from 'vue-property-decorator'
import Partner from '@/components/public/Partner.vue'
import router from '@/router'
import cartsApi from '@/api/cartsApi'
import NoData from '@/components/ui/NoData.vue'
import listApi from '@/api/listApi'
import buyApi from '@/api/buyApi'
import moment from 'moment'
import ShowImg from '@/components/ui/ShowImg.vue'

@Component({
  components: {
    Partner,
    NoData,
    ShowImg
  },
  filters: {
    formatYMD(value: any) {
      return moment(Number(value)).format('YYYY年MM月DD日')
    }
  }
})
export default class Carts extends Vue {
  public lockSpinning?: boolean = false;
  private delAlert: boolean = false
  private resources: any = ''
  private allPirce: number = 0
  private priceType: string = 'GOLDCOINS'
  private operation: any = {
  }

  private res: any = {
    cartslist: [],
    partnerList: [

    ]
  }

  public mounted() {
    this.getPartnerList()
    this.getCartsList()
  }

  // 购物车列表
  protected getCartsList(): void {
    cartsApi.getCartsList({
    }).then((res) => {
      if (res.code === 200) {
        this.res.cartslist = res.data
        let cartsLenth = this.res.cartslist.length
        this.$store.commit('changeCartsAmount', cartsLenth)
      }
    })
  }

  // 获取资源
  protected getPartnerList(): void {
    listApi.getHotList({
      businessType: 'PROMOTION',
      position: 'CARTS_BOTTOM',
    }).then((res) => {
      if (res.code === 200 && res.data.length > 0) {
        this.res.partnerList = res.data
      }
    })
  }


  // 编辑订单
  protected editGoods(item: any): void {
    this.$router.push({ name: 'buy', query: { step: '2', id: item.businessResourceVO.id } })
  }

  // 删除商品
  protected deleteGoods(item: any): void {
    const that = this
    this.$confirm({
      title: '你确定要删除该商品吗？',
      content: '删除后不可恢复',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        cartsApi.delCartsItem({
          id: item.id
        }).then((res) => {
          if (res.code === 200) {
            that.getCartsList()
          }
        })
      }
    });
  }

  // 点击商品到详情
  protected goDelails(item: any): void {
    if (item.sellState) {
      this.$message.warning('资源已下架');
      return
    }
    router.push({ name: 'goods-details', query: { id: item.businessResourceVO.id, carts: 'CART' } })
    // if (item.soldOut) {
    //   this.$message.warning('资源已售罄');

    // }
  }

  // 单选按钮
  protected changeGoods(): void {
    if (this.resources.coinType === 'SILVERCOINS') {
      this.allPirce = this.resources.paySilverCoins
    } else {
      this.allPirce = this.resources.payGoldCoins
    }
    this.priceType = this.resources.coinType
    console.log(this.resources)
  }

  // 锁定库存
  public locked(data?: any, callback?: () => void) {
      buyApi.locked(data).then((res) => {
        if (res.code == 200 && res.data.orderLockStatusEnum == 1) {
          callback ? callback() : '';
        } else {
          setTimeout(() => {
            this.locked(data, callback);
          }, 1000)
        }
      })
  }

  // 选择了结算
  protected gpPay(): void {
    if (this.resources === '') {
      this.$message.warning('请选择商品在购买');
      return
    }
    buyApi.buy({
      shopCarId: this.resources.id,
      resouceId: this.resources.businessResourceVO.id,
      orderCommitEnum: 'CAR'
    }).then((res) => {
       this.lockSpinning = true;
       if (res.code === 200 && res.data) {
        this.locked({orderCode: res.data.orderCode}, () => {
          router.push({ name: 'buy', query: { step: '4', id: this.resources.businessResourceVO.id, orderCommitEnum: 'CAR', noStep: 'noStep', orderCode: res.data.orderCode } })
        })
      }
    })
  }
}
